import { t } from 'ttag'

import NOFlagIcon from 'assets/icons/flags/no.svg'
import UKFlagIcon from 'assets/icons/flags/uk.svg'

import NORoundFlagIcon from 'assets/icons/flags/no-round.svg'
import UKRoundlagIcon from 'assets/icons/flags/uk-round.svg'

const EN_CODE = 'en'
const NB_CODE = 'nb'

const EN_SYMBOL = 'EN'
const NOR_SYMBOL = 'NOR'

export const LANGUAGE_CODES = { EN_CODE, NB_CODE }

export const getLanguages = () => [
  {
    icon: UKFlagIcon,
    roundIcon: UKRoundlagIcon,
    label: t`English`,
    original: 'English',
    value: EN_CODE,
  },
  {
    icon: NOFlagIcon,
    roundIcon: NORoundFlagIcon,
    label: t`Norwegian`,
    original: 'Norsk',
    value: NB_CODE,
  },
]

export const getLanguageSymbol = code => {
  const symbols = {
    [EN_CODE]: EN_SYMBOL,
    [NB_CODE]: NOR_SYMBOL,
  }

  return symbols[code]
}
